import React, { PureComponent } from 'react';
import { forEach, get, filter, isEmpty, has, omitBy } from 'lodash';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT } from '../../../../constants/connectionCategories';
import UIUtils from '../../../../lib/UIUtils';
import { isUndefined } from 'lodash';

class TemplatizedScriptSourceConfiguration extends PureComponent {
  componentDidMount() {
    if (!this.props.credentialsLoaded) {
      this.props.loadDataCredentials();
    }
  }

  render() {
    const { data, credentials, config, configFields } = this.props;
    let credentialID = data.data_credentials
      ? data.data_credentials
      : get(config, 'credentials[0].id', null);
    const creds = get(credentials, credentialID, {});

    let credentialFields = filter(configFields, (field) => field.type === 'script_credential');
    let { templatizedScriptConfig, scriptCredentialsData } =
      UIUtils.buildTemplatizedScriptConfigFromSource(data, configFields, credentials);

    let anyValidScriptCredential = false;
    forEach(scriptCredentialsData, (data, name) => {
      if (data && data.selectedCredentialInfo) {
        anyValidScriptCredential = true;
        templatizedScriptConfig[name] = data.selectedCredentialInfo;
      }
    });
    if (!anyValidScriptCredential && !isEmpty(creds)) {
      forEach(credentialFields, (field) => {
        if (
          field.credential_type === creds.credentials_type &&
          has(templatizedScriptConfig, field.name)
        ) {
          templatizedScriptConfig[field.name] = creds;
        }
      });
    }

    // removing undefined fields
    templatizedScriptConfig = omitBy(templatizedScriptConfig, isUndefined);

    let visibleFields = filter(configFields, (field) => {
      return (
        !UIUtils.shouldHideField(field, templatizedScriptConfig) &&
        UIUtils.shouldRenderField(field, templatizedScriptConfig)
      );
    });

    return (
      <div>
        <ConfigurationFields
          {...this.props}
          connectionCategory={CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT}
          config={templatizedScriptConfig}
          configFields={visibleFields}
        />
      </div>
    );
  }
}

export default TemplatizedScriptSourceConfiguration;
